 import "../styles/courseSingle.css";
 
    import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
 
 
const SingleCourseLoader = () => {
 

  return (
    <div className='single-course-wrapper'>
      <div className='single-course-header'>
        <div className='course-breadcrumb'>
           <Skeleton width="80px" height="15px" /> |
           <Skeleton width="80px" height="15px" />
        </div>

        <div className='single-course-el'>
          
          <div className='single-couch-details'>
   
            <div className='single-couch-name'>
               <Skeleton width="100px" height="15px" />
                <Skeleton width="200px" height="15px" />
            </div>
            <div className='single-couch-category'>
               <Skeleton width="100px" height="15px" />
                <Skeleton width="200px" height="15px" />
            </div>
            <div className='single-couch-duration'>
               <Skeleton width="100px" height="15px" />
                <Skeleton width="200px" height="15px" />
            </div>
          </div>
        </div>
      </div>

      <div className='single-course-info'>
        <div className='single-course-info-container' style={{backgroundColor:"white", padding:"10px", borderRadius:"10PX"}}>
         
                <Skeleton width="200px" height="25px" style={{marginBottom:'20px'}}/>
       
               <Skeleton width="95%" height="15px" />
                <Skeleton width="98%" height="15px" />
                <Skeleton width="90%" height="15px" />
                <Skeleton width="100%" height="15px" />
                <Skeleton width="85%" height="15px" />

        </div>

        <div className="course-booking-button"  style={{backgroundColor:"white",  }}>
          <h3>    <Skeleton width="200px" height="15px" /></h3>
          <div className="single-course-button">
               <Skeleton width="200px" height="25px" />
          </div>

              <Skeleton width="200px" height="15px" />

 
          
                       <Skeleton width="30%" height="15px" />
                <Skeleton width="50%" height="15px" />
                <Skeleton width="40%" height="15px" />
           
   
        </div>
      </div>

  

 
    </div>
  );
};

export default SingleCourseLoader;
